module.exports = __webpack_public_path__ + "img/SOL_icon.e848ba63.png";